<template>
    <label
        :class="{ on: modelValue, off: !modelValue }"
        class="flex-shrink-0 switch form-check-label switch-sm switch-pill"
    >
        <input
            :checked="modelValue"
            :disabled="disabled"
            class="switch-input form-check-input"
            name="operability"
            type="checkbox"
            @change="$emit('update:modelValue', $event.target.checked)"
        />
        <span class="switch-slider" />
    </label>
</template>
<script setup>
const props = defineProps(['color', 'disabled', 'modelValue']);
</script>
